export const ADD_SHIFT = "ADD_SHIFT";
export const ADD_SHIFT_SUCCESS = "ADD_SHIFT_SUCCESS";
export const ADD_SHIFT_FAIL = "ADD_SHIFT_FAIL";

export const GET_SHIFTS = "GET_SHIFTS";
export const GET_SHIFTS_SUCCESS = "GET_SHIFTS_SUCCESS";
export const GET_SHIFTS_FAIL = "GET_SHIFTS_FAIL";

export const UPDATE_SHIFT = "UPDATE_SHIFT";
export const UPDATE_SHIFT_SUCCESS = "UPDATE_SHIFT_SUCCESS";
export const UPDATE_SHIFT_FAIL = "UPDATE_SHIFT_FAIL";

export const DELETE_SHIFT = "DELETE_SHIFT";
export const DELETE_SHIFT_SUCCESS = "DELETE_SHIFT_SUCCESS";
export const DELETE_SHIFT_FAIL = "DELETE_SHIFT_FAIL";

export const SHIFT_LOGS = "SHIFT_LOGS";
export const SHIFT_LOGS_SUCCESS = "SHIFT_LOGS_SUCCESS";
export const SHIFT_LOGS_FAIL = "SHIFT_LOGS_FAIL";

export const SHIFT_REPORT = "SHIFT_REPORT";
export const SHIFT_REPORT_SUCCESS = "SHIFT_REPORT_SUCCESS";
export const SHIFT_REPORT_FAIL = "SHIFT_REPORT_FAIL";

export const CANCEL_SHIFT_ADMIN = "CANCEL_SHIFT_ADMIN";
export const CANCEL_SHIFT_ADMIN_SUCCESS = "CANCEL_SHIFT_ADMIN_SUCCESS";
export const CANCEL_SHIFT_ADMIN_FAIL = "CANCEL_SHIFT_ADMIN_FAIL";
